<template>
  <div class="form-step-container">
    <!-- תגית השלב -->
    <div class="step-badge">{{ words.step }} {{ step }}</div>
    <h1 class="main-title">{{ words.nice_to_meet_you }}</h1>

    <form class="form_steps" @submit.prevent="submit">
      <!-- כרטיסייה 1: שם פרטי ומשפחה -->
      <div class="card-box">
        <label class="card-title">{{ words.whats_your_name }}</label>

        <div class="options_grid">
          <div class="form-item floating_label">
            <input 
              id="first_name" 
              v-model.trim="form.first_name" 
              type="text" 
              autocomplete="given-name" 
              placeholder=" "
              required 
            />
            <label for="first_name">{{ words.first_name }}</label>
          </div>

          <div class="form-item floating_label">
            <input 
              id="last_name" 
              v-model.trim="form.last_name" 
              type="text" 
              autocomplete="family-name" 
              placeholder=" "
              required 
            />
            <label for="last_name">{{ words.last_name }}</label>
          </div>
        </div>
      </div>

      <!-- כרטיסייה 2: פרטי התקשרות -->
      <div class="card-box">
        <label class="card-title">{{ words.how_well_get_in_touch }}</label>

        <div class="inputs-stack">
          <div class="form-item floating_label">
            <input 
              id="email" 
              v-model.trim="form.email" 
              type="email" 
              inputmode="email" 
              autocomplete="email" 
              placeholder=" "
              required 
            />
            <label for="email">{{ words.my_email_is }}</label>
          </div>

          <div class="form-item floating_label">
            <input 
              id="phone" 
              v-model.trim="form.phone" 
              type="tel" 
              inputmode="numeric" 
              autocomplete="tel" 
              placeholder=" "
              required 
              @keypress="isNumber" 
            />
            <label for="phone">{{ words.my_number_is }}</label>
          </div>
        </div>
      </div>

      <!-- כפתורי פעולה בתחתית -->
      <div class="action-footer">
        <button 
          type="button" 
          class="btn-back" 
          @click="emit('returnStep')"
        >
          ➔ <span>{{ words.return_step }}</span>
        </button>

        <input type="submit" class="btn btn-primary" :value="words.procced" />
      </div>
    </form>
  </div>
</template>

<script setup>
import { reactive, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

// Props
const props = defineProps({
  numbersInfo: { type: Array, required: true },
  step: { type: Number, required: true },
  numbers: { type: Array, required: true },
  parentForm: { type: Object, required: true }
})

// Emits
const emit = defineEmits(['saveData', 'returnStep'])

const store = useStore()

// State
const form = reactive({
  first_name: '',
  last_name: '',
  email: '',
  phone: ''
})

// Computed
const words = computed(() => store.state.words || {})

// Lifecycle Hooks
onMounted(() => {
  if (props.parentForm && Object.keys(props.parentForm).length) {
    Object.assign(form, props.parentForm)
  }
})

// Methods
const isNumber = (evt) => {
  const charCode = evt.which ? evt.which : evt.keyCode
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault()
  }
}

const submit = () => {
  emit('saveData', { ...form })
}
</script>

<style scoped lang="scss">

$purple-primary: #6B11D8;
$purple-light: #F5EFFF;
$purple-hover: #550bb1;
$bg-light: #F8F9FD;
$text-dark: #2B2635;
$text-muted: #718096;
$border-color: #E2E8F0;
$radius: 16px;

.form-step-container {
  direction: rtl;
  text-align: right;
  font-family: inherit;

  /* מניעת גלילה והתאמה לגובה המסך */
  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;

.step-badge {
  display: block;
  width: 100%;               /* מותח את הרקע לרוחב כל השורה */
  box-sizing: border-box;
  background: #F5EFFF;       /* רקע סגול בהיר */
  color: #6B11D8;            /* צבע טקסט סגול */
  font-size: 13px;
  font-weight: 700;
  padding: 8px 16px;
  border-radius: 20px;
  margin-bottom: 12px;
  text-align: right;         /* יישור הטקסט לימין */
}

  .main-title {
    font-size: 22px;
    font-weight: 800;
    color: $text-dark;
    margin: 0 0 12px 0;
  }

  .form_steps {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    justify-content: space-between;
  }

  /* כרטיסיות עיצוב */
  .card-box {
    background: #ffffff;
    border: 1px solid $border-color;
    border-radius: $radius;
    padding: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);

    .card-title {
      display: block;
      font-size: 14px;
      font-weight: 700;
      color: $text-dark;
      margin-bottom: 12px;
    }
  }

  .options_grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 10px;
  }

  .inputs-stack {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  /* תווית צפה (Floating Label) מותאמת לסטייל */
  .floating_label {
    position: relative;
    width: 100%;

    input {
      width: 100%;
      padding: 10px 14px;
      border: 1.5px solid $border-color;
      border-radius: 12px;
      font-size: 14px;
      outline: none;
      transition: all 0.2s ease;
      background: #ffffff;
      color: $text-dark;
      box-sizing: border-box;

      &:focus {
        border-color: $purple-primary;
        box-shadow: 0 0 0 3px rgba(107, 17, 216, 0.1);
      }

      &:focus + label,
      &:not(:placeholder-shown) + label {
        top: 0;
        right: 10px;
        transform: translateY(-50%);
        font-size: 11px;
        font-weight: 600;
        color: $purple-primary;
        background-color: #ffffff;
        padding: 0 6px;
      }
    }

    label {
      position: absolute;
      top: 50%;
      right: 14px;
      transform: translateY(-50%);
      font-size: 13px;
      color: $text-muted;
      pointer-events: none;
      transition: all 0.2s ease;
    }
  }

  /* סרגל כפתורים בתחתית */
  .action-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-top: auto;
    padding-top: 10px;

    .btn-back {
      background: transparent;
      border: none;
      color: $text-muted;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 20px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      transition: all 0.2s ease;

      &:hover {
        color: $purple-primary;
        background-color: $purple-light;
      }
    }

    .btn-primary {
      border: none;
      background: $purple-primary;
      color: #ffffff;
      padding: 10px 24px;
      border-radius: 30px;
      font-size: 13px;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 4px 12px rgba(107, 17, 216, 0.2);

      &:hover {
        background: $purple-hover;
        box-shadow: 0 6px 16px rgba(107, 17, 216, 0.3);
      }
    }
  }
}

</style>